import I18n from 'I18n';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { FloatingAlertStore } from 'foundations-components/transitional/components/FloatingAlertList';
import { useCallback, useMemo, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getContentModelId, getPreviewKey } from 'ContentEditorUI/redux/selectors/baseContentModelSelectors';
// @ts-expect-error not typed
import { setScrollTo } from 'ContentEditorUI/redux/actions/baseSettingsActions';
import { getIsReadOnlyMode } from 'ContentEditorUI/redux/selectors/appStatusSelectors';
import { undoModuleReducerChange, redoModuleReducerChange
//@ts-expect-error no types
} from 'ContentEditorUI/redux/actions/undoRedoActions';
import { openModal
// @ts-expect-error not typed
} from 'ContentEditorUI/redux/actions/appActions';
// @ts-expect-error not typed
import { routeToPage } from 'ContentEditorUI/redux/actions/routingActions';
import { selectCanUndoInstanceEditingState, selectCanRedoInstanceEditingState } from 'structured-content-lib/redux/selectors/instanceEditSelectors';
import { SettingsModalSections } from 'structured-content-lib/constants/enums';
import { createInstance } from '../api';
import { selectInstanceId, selectInstanceGroupId } from '../data/editor/instance';
import { selectInstanceUrl } from '../data/editor';
import { SETTINGS_MODAL } from '../constants';
import { getDetailsUrl, getEditorUrl } from 'case-study-lib/utils/urls';
import { hasEditorPermission, hasPublisherPermission, getIsUngatedForEditorTour, getIsUngatedForRevisionHistory } from 'case-study-lib/utils/auth';
import { getThemeSettingsEditorUrl } from 'case-study-lib/utils/urls';
import { selectContentThemePath, selectContentTemplatePath } from 'structured-content-lib/redux/selectors/contentThemeSelectors';
import { selectInstanceGroupName, selectInstanceGroupLanguage } from 'structured-content-lib/redux/selectors/instanceGroupSelectors';
import { useStartOnboardingTour } from '../editor/components/OnboardingTour';
import { usageTracker } from '../utils/usageTracker';
import { jsx as _jsx } from "react/jsx-runtime";
const useSettingsDropdownOptions = () => {
  const dispatch = useDispatch();
  const openSettingsModalFromNavItem = useCallback(navItem => {
    dispatch(openModal(SETTINGS_MODAL));
    dispatch(setScrollTo(navItem));
  }, [dispatch]);
  return useMemo(() => {
    const settingsDropdownOptions = Object.values(SettingsModalSections).map(section => ({
      id: section,
      text: /*#__PURE__*/_jsx(FormattedMessage, {
        message: `caseStudyEditor.settingsModal.tabLabel.${section}`
      }),
      onClick: () => openSettingsModalFromNavItem(section)
    }));
    return settingsDropdownOptions;
  }, [openSettingsModalFromNavItem]);
};
export const useNavigationGroups = ({
  onDeleteClick,
  onCloneClick
}) => {
  const dispatch = useDispatch();
  const isReadOnlyMode = useSelector(getIsReadOnlyMode);
  const hasPublishPermission = hasPublisherPermission();
  const hasEditPermission = hasEditorPermission();
  const canRedoModules = useSelector(selectCanRedoInstanceEditingState);
  const canUndoModules = useSelector(selectCanUndoInstanceEditingState);
  const instanceId = useSelector(selectInstanceId);
  const [isCreatingCaseStudy, setIsCreatingCaseStudy] = useState(false);
  const settingsDropdownOptions = useSettingsDropdownOptions();
  const contentId = useSelector(getContentModelId);
  const previewKey = useSelector(getPreviewKey);
  const instanceUrl = useSelector(selectInstanceUrl);
  const shareablePreviewURL = instanceUrl && previewKey && contentId && `${instanceUrl}?hs_preview=${previewKey}-${contentId}`;
  const groupId = useSelector(selectInstanceGroupId);
  const groupName = useSelector(selectInstanceGroupName);
  const groupLanguage = useSelector(selectInstanceGroupLanguage);
  const themePath = useSelector(selectContentThemePath);
  const templatePath = useSelector(selectContentTemplatePath);
  const isUngatedForEditorTour = getIsUngatedForEditorTour();
  const startOnboardingTour = useStartOnboardingTour();
  const handleTakeTourClick = useCallback(() => {
    usageTracker.track('clickedTakeTourManuallyFromHelp');
    startOnboardingTour();
  }, [startOnboardingTour]);
  const helpMenuItem = useMemo(() => {
    return isUngatedForEditorTour ? [{
      id: 'help',
      text: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "caseStudyEditor.parentMenuItems.help"
      }),
      children: [{
        id: 'takeTour',
        text: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "caseStudyEditor.childMenuItems.takeTour"
        }),
        onClick: handleTakeTourClick
      }]
    }] : [];
  }, [isUngatedForEditorTour, handleTakeTourClick]);
  const navGroups = useMemo(() => [{
    id: 'file',
    text: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "caseStudyEditor.parentMenuItems.file"
    }),
    children: [{
      id: 'new',
      disableLink: !hasEditPermission || isReadOnlyMode,
      text: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "caseStudyEditor.childMenuItems.new.label"
      }),
      loading: isCreatingCaseStudy,
      onClick: () => {
        if (groupId) {
          setIsCreatingCaseStudy(true);
          createInstance(groupId, I18n.text('caseStudyEditor.defaultTitle')).then(response => {
            var _response$entity;
            setIsCreatingCaseStudy(false);
            if (response !== null && response !== void 0 && (_response$entity = response.entity) !== null && _response$entity !== void 0 && (_response$entity = _response$entity.values) !== null && _response$entity !== void 0 && _response$entity.hs_id) {
              window.location.href = getEditorUrl(response.entity.values.hs_id);
            }
          }).catch(() => {
            setIsCreatingCaseStudy(false);
            FloatingAlertStore.addAlert({
              message: /*#__PURE__*/_jsx(FormattedMessage, {
                message: "caseStudyEditor.childMenuItems.new.createInstanceError"
              }),
              type: 'danger'
            });
          });
        }
      },
      tooltipLabel: !hasEditPermission && /*#__PURE__*/_jsx(FormattedMessage, {
        message: "caseStudyEditor.childMenuItems.new.disabledTooltip"
      })
    }, {
      id: 'clone',
      disableLink: !hasEditPermission || isReadOnlyMode,
      text: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "caseStudyEditor.childMenuItems.clone.label"
      }),
      onClick: () => {
        if (instanceId && groupId) {
          onCloneClick();
        }
      },
      tooltipLabel: !hasEditPermission && /*#__PURE__*/_jsx(FormattedMessage, {
        message: "caseStudyEditor.childMenuItems.clone.disabledTooltip"
      })
    }, {
      id: 'deletePage',
      disableLink: !hasPublishPermission || isReadOnlyMode,
      text: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "caseStudyEditor.childMenuItems.delete.label"
      }),
      onClick: () => {
        if (instanceId) {
          onDeleteClick();
        }
      },
      tooltipLabel: !hasPublishPermission && /*#__PURE__*/_jsx(FormattedMessage, {
        message: "caseStudyEditor.childMenuItems.delete.disabledTooltip"
      })
    }]
  }, {
    id: 'edit',
    text: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "caseStudyEditor.parentMenuItems.edit"
    }),
    children: [{
      id: 'undo',
      text: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "caseStudyEditor.childMenuItems.undo.label"
      }),
      onClick: () => dispatch(undoModuleReducerChange()),
      disableLink: !hasEditPermission || !canUndoModules || isReadOnlyMode,
      tooltipLabel: !hasEditPermission && /*#__PURE__*/_jsx(FormattedMessage, {
        message: "caseStudyEditor.childMenuItems.redo.disabledTooltip"
      })
    }, {
      id: 'redo',
      text: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "caseStudyEditor.childMenuItems.redo.label"
      }),
      onClick: () => dispatch(redoModuleReducerChange()),
      disableLink: !hasEditPermission || !canRedoModules || isReadOnlyMode,
      tooltipLabel: hasEditPermission ? !canRedoModules && /*#__PURE__*/_jsx(FormattedMessage, {
        message: "caseStudyEditor.childMenuItems.redo.nothingToRedoTooltip"
      }) : /*#__PURE__*/_jsx(FormattedMessage, {
        message: "caseStudyEditor.childMenuItems.redo.disabledTooltip"
      })
    }, {
      id: 'themeSettings',
      text: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "caseStudyEditor.childMenuItems.themeSettings"
      }),
      onClick: event => {
        if (groupId) {
          const redirectUrl = getThemeSettingsEditorUrl({
            themeTitle: groupName,
            language: groupLanguage,
            themePath,
            templatePath
          });
          if (event.metaKey || event.ctrlKey) {
            window.open(redirectUrl, '_blank');
          } else {
            window.location.href = redirectUrl;
          }
        }
      },
      disableLink: isReadOnlyMode
    }]
  }, {
    id: 'view',
    text: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "caseStudyEditor.parentMenuItems.view"
    }),
    children: [...(getIsUngatedForRevisionHistory() ? [{
      id: 'revisions',
      text: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "caseStudyEditor.childMenuItems.revisions"
      }),
      onClick: () => dispatch(routeToPage('revisions'))
    }] : []), {
      id: 'details',
      text: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "caseStudyEditor.childMenuItems.details"
      }),
      href: getDetailsUrl(instanceId)
    }, {
      id: 'preview',
      text: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "caseStudyEditor.childMenuItems.preview"
      }),
      href: shareablePreviewURL,
      external: true,
      hideLink: !shareablePreviewURL
    }]
  }, {
    id: 'settings',
    text: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "caseStudyEditor.parentMenuItems.settings"
    }),
    children: settingsDropdownOptions
  }, ...helpMenuItem], [hasEditPermission, isReadOnlyMode, isCreatingCaseStudy, hasPublishPermission, canUndoModules, canRedoModules, instanceId, shareablePreviewURL, settingsDropdownOptions, groupId, onCloneClick, onDeleteClick, dispatch, groupName, groupLanguage, themePath, templatePath, helpMenuItem]);
  return navGroups;
};